import { fetchConfig } from "../_helpers";

let apiUrlPromise = fetchConfig().then(config => {
    if (config) {
        return config.apiUrl;
    } else {
        return '';
    }
});

export const login = async (username, password) => {
    const apiUrl = await apiUrlPromise;
    const response = await fetch(apiUrl + '/api/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return { data: await response.json(), status: response.status }
};

export const login2fa = async (twoFACode, twoFAToken) => {
    const apiUrl = await apiUrlPromise;
    const response = await fetch(apiUrl + '/api/login/2fa', {
        method: 'POST',
        body: JSON.stringify({ twoFACode, twoFAToken }),
        headers: {
            'Content-Type': 'application/json'
        }
    })
    return { data: await response.json(), status: response.status }
};

export const logout = async (shouldRedirect = true) => {
    return await fetchWithAuth('/api/login/logout', {
        method: 'GET'
    }, shouldRedirect);
};

export const getUsers = async (searchText) => {
  const queryParams = searchText ? `?searchText=${searchText}` : '';
  return await fetchWithAuth(`/api/users${queryParams}`, {
    method: 'GET'
  });
};

export const getUserAccount = async (shouldRedirect = true) => {
  return await fetchWithAuth('/api/user/account', {
    method: 'GET'
  }, shouldRedirect);
};

export const getLastConnection = async (personId) => {
    return await fetchWithAuth(`/api/audit/getLastConnection/${personId}`, {
        method: 'GET'
    });
};

export const updateUserAccount = async (updatedUserData) => {
  return await fetchWithAuth('/api/user/account', {
    method: 'PUT',
    body: JSON.stringify(updatedUserData)
  });
};

export const updatePassword = async (oldPassword, newPassword) => {
  return await fetchWithAuth('/api/user/password', {
    method: 'PUT',
    body: JSON.stringify({ oldPassword, newPassword })
  });
};

export const createUser = async (userData) => {
  return await fetchWithAuth('/api/user', {
    method: 'POST',
    body: JSON.stringify(userData)
  });
};

export const getUser = async (personId) => {
  return await fetchWithAuth(`/api/user/${personId}`, {
    method: 'GET'
  });
};

export const updateUser = async (personId, userData) => {
  return await fetchWithAuth(`/api/user/${personId}`, {
    method: 'PUT',
    body: JSON.stringify(userData)
  });
};

export const deleteUser = async (personId) => {
  return await fetchWithAuth(`/api/user/${personId}`, {
    method: 'DELETE'
  });

}

export const getEquipment = async (equipmentIdent) => {
  return await fetchWithAuth(`/api/equipment/${equipmentIdent}`, {
    method: 'GET'
  });
};

export const updateEquipmentTelephone = async (equipmentIdent, equipmentTelephone, otherTelephone, telephone3) => {
  return await fetchWithAuth(`/api/equipment/${equipmentIdent}`, {
    method: 'PUT',
    body: JSON.stringify({ equipmentTelephone, otherTelephone, telephone3 })
  });
};

export const getPseudoCode = async (equipmentIdent, overrideCodeId) => {
  return await fetchWithAuth(`/api/equipment/${equipmentIdent}/lock?overrideCodeId=${overrideCodeId}`, {
    method: 'GET'
  });
};

export const getResidentMobileDevices = async (equipmentIdent) => {
    return await fetchWithAuth(`/api/resident/equipment/${equipmentIdent}`, {
        method: 'GET'
    });
};

export const updateResidentTam = async (residentId, residentDevice) => {
    return await fetchWithAuth(`/api/resident/${residentId}/updateTam`,
        {
            method: 'PUT',
            body: JSON.stringify(residentDevice)
        }
    )
}

export const updateResidentPhone= async (residentId, residentPhones) => {
    return await fetchWithAuth(`/api/resident/${residentId}/updatePhone`,
        {
            method: 'PUT',
            body: JSON.stringify(residentPhones)
        }
    )

}
export const insertPseudoCode = async (data) => {
    console.log(data);
    return await fetchWithAuth(`/api/equipment/${data.equipmentIdent}/lock`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const deletePseudoCode = async (data) => {
    return await fetchWithAuth(`/api/equipment/${data.equipmentIdent}/unlock`, {
    method: 'DELETE',
        body: JSON.stringify(data)
  });
};

export const getLockTime = async (equipmentIdent) => {
  return await fetchWithAuth(`/api/equipment/${equipmentIdent}/lockTime`, {
    method: 'GET'
  });
};

export const getCallHistory = async (equipmentIdent) => {
  return await fetchWithAuth(`/api/equipment/${equipmentIdent}/call-history`, {
    method: 'GET'
  });
};

export const getControlCentres = async () => {
  return await fetchWithAuth(`/api/controlCentre`, {
    method: 'GET'
  });
};

export const getAudits = async (limit, offset, sortField, sortDirection, searchText = "") => {
  const queryParams = `?limit=${limit}&offset=${offset}&searchText=${searchText}&sortField=${sortField}&sortDirection=${sortDirection}`;
  return await fetchWithAuth(`/api/audit${queryParams}`, {
    method: 'GET'
  });
};

export const getReactConfig = async () => {
    return await fetchWithAuth(`/api/config`, {
        method: 'GET'
    });
};

export const getPseudoCodeText = async (pseudoCodeId) => {
  return await fetchWithAuth(`/api/pseudoCode/${pseudoCodeId}/text`, {
    method: 'GET'
  });
};

export const getPseudoCodes = async (searchparam) => {
  if (searchparam) {
    return await fetchWithAuth(`/api/pseudoCode?searchparam=${searchparam}`, {
      method: 'GET'
    })
  } else {
    return await fetchWithAuth('/api/pseudoCode', {
      method: 'GET'
    })
  }
}

export const getControlCentreConfigs = async (centreid) => {
  return await fetchWithAuth(`/api/controlCentre/${centreid}/pseudoCodeConfig`, {
    method: 'GET'
  })
}

export const setControlCentrePseudocodeConfig = async (centreid,config) => {
  return await fetchWithAuth(`/api/controlCentre/${centreid}/pseudoCodeConfig`,
    {
      method: 'POST',
      body: JSON.stringify(config)
    }
  )
}

export const updateControlCentrePseudocodeConfig = async (centreid, configid, overrideid) => {
  return await fetchWithAuth(`/api/controlCentre/${centreid}/pseudoCodeConfig/${configid}`,
    {
      method: 'PUT',
      body: JSON.stringify(overrideid)
    }
  )
}

export const updateControlCentreInterventionType = async (centreid, configid, interventiontype) => {
    console.log(interventiontype);
    return await fetchWithAuth(`/api/controlCentre/${centreid}/pseudoCodeConfig/${configid}/interventionType`,
        {
            method: 'PUT',
            body: JSON.stringify(interventiontype)
        }
    )
}

export const deleteControlCentrePseudocodeConfig = async (centreid, configid) => {
  return await fetchWithAuth(`/api/controlCentre/${centreid}/pseudoCodeConfig/${configid}`,
    {
      method: 'DELETE'
    }
  )
}

export const updateBlockingTimeSet = async (centreid, configid, timeset) => {
  return await fetchWithAuth(`/api/controlCentre/${centreid}/pseudoCodeConfig/${configid}/blockingTimeSet`,
    {
      method: 'PUT',
      body: JSON.stringify(timeset)
    }
  )
}

export const resetBlockingTimeSet = async (centreid, configid, reset) => {
  return await fetchWithAuth(`/api/controlCentre/${centreid}/pseudoCodeConfig/${configid}/blockingTimeSet`,
    {
      method: 'DELETE',
      body: JSON.stringify(reset)
    }
  )
}

export const integration = async (config) => {
    return await fetchWithAuth(`/api/integration`,
        {
            method: 'POST',
            body: JSON.stringify(config)
        }
    )
}

export const getIntegrationActions = async () => {
    return await fetchWithAuth(`/api/integration/actions`, {
        method: 'GET'
    })
}

export const getInterventionTypes = async () => {
    return await fetchWithAuth(`/api/interventionType`, {
        method: 'GET'
    });
};

export const getInterventionType = async (id) => {
    return await fetchWithAuth(`/api/interventionType/${id}`, {
        method: 'GET'
    });
};

export const createInterventionType= async (data) => {
    return await fetchWithAuth('/api/interventionType', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};



export const updateInterventionType = async (id, data) => {
    return await fetchWithAuth(`/api/interventionType/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
};

export const deleteInterventionType = async (id) => {
    return await fetchWithAuth(`/api/interventionType/${id}`, {
        method: 'DELETE'
    });

}

export const insertIntervention = async (data) => {
    console.log(data);
    return await fetchWithAuth(`/api/intervention`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const endIntervention = async (data) => {
    console.log(data);
    return await fetchWithAuth(`/api/intervention/${data.id}/end`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
};

export const retryIntervention = async (data) => {
    return await fetchWithAuth(`/api/intervention/${data.id}/retry`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
};

export const registerPseudoCodeChecked = async (id, data) => {
    console.log(data);
    return await fetchWithAuth(`/api/intervention/${id}/registerPseudoCodeChecked`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
};

export const getInterventions = async (params) => {
    console.log(params);
    const query = new URLSearchParams(params).toString();
    return await fetchWithAuth(`/api/intervention?${query}`, {
        method: 'GET'
    });
};

export const getPendingInterventions = async () => {
    return await fetchWithAuth(`/api/intervention/pending`, {
        method: 'GET'
    });
};

export const getLastLocation = async (phone) => {
    return await fetchWithAuth(`/api/location/${phone}`, {
        method: 'GET'
    });
};

/**
 * Función que realiza una llamada a la API con el token de autenticación.
 * @param {string} path
 * @param {RequestInit | undefined} options
 */
async function fetchWithAuth(path, options, shouldRedirect = true) {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: token ? `Bearer ${token}` : undefined,
    'Content-Type': 'application/json'
    }
    const apiUrl = await apiUrlPromise;
    const response = await fetch(apiUrl + path, { ...options, headers });
  if (shouldRedirect && response.status === 401) {
    window.location.href = '/login';
    return;
  }

  const status = response.status;
  let data = null;
  try {
    data = await response.json();
  } catch {
    console.error('No se pudo parsear la respuesta');
  }

  return { data, status };
}